var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReceiptIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/receipt-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "receipt-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.0207 41.0416C15.729 39.2083 18.3332 39.3541 19.8332 41.3541L21.9373 44.1666C23.6248 46.3958 26.354 46.3958 28.0415 44.1666L30.1457 41.3541C31.6457 39.3541 34.2498 39.2083 35.9582 41.0416C39.6665 45 42.6873 43.6875 42.6873 38.1458V14.6666C42.7082 6.27079 40.7498 4.16663 32.8748 4.16663H17.1248C9.24984 4.16663 7.2915 6.27079 7.2915 14.6666V38.125C7.2915 43.6875 10.3332 44.9791 14.0207 41.0416Z",
    stroke: "#083844",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.8666 22.9167H16.8854",
    stroke: "#083844",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M22.7051 22.9166H34.1634",
    stroke: "#083844",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M16.8666 14.5833H16.8854",
    stroke: "#083844",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M22.7051 14.5834H34.1634",
    stroke: "#083844",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceiptIcon);
export default __webpack_public_path__ + "static/media/receipt-icon.388cdc468ba28364dc9411f086799f67.svg";
export { ForwardRef as ReactComponent };